import { z } from 'zod'

const time = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Use the HH:MM format.')

export const slotSchema = z.object({
  subjectId: z.string().min(1, 'Choose a subject.'),
  teacherId: z.string(),
  roomId: z.string(),
})
export type SlotFormValues = z.infer<typeof slotSchema>

export const periodSchema = z
  .object({
    name: z.string().trim().min(1, 'Enter a period name.').max(50, 'Use at most 50 characters.'),
    startTime: time,
    endTime: time,
    isBreak: z.boolean(),
    shiftId: z.string(),
  })
  .refine((v) => v.endTime > v.startTime, {
    path: ['endTime'],
    message: 'End time must be after start time.',
  })
export type PeriodFormValues = z.infer<typeof periodSchema>

export const roomSchema = z.object({
  name: z.string().trim().min(1, 'Enter a room name.').max(50, 'Use at most 50 characters.'),
  kind: z.enum(['classroom', 'lab', 'hall', 'gym', 'library', 'other']),
  capacity: z
    .string()
    .trim()
    .refine(
      (v) => v === '' || (/^\d+$/.test(v) && Number(v) >= 1 && Number(v) <= 1000),
      'Enter a number between 1 and 1000.',
    ),
  active: z.boolean(),
})
export type RoomFormValues = z.infer<typeof roomSchema>

export const ROOM_KINDS = ['classroom', 'lab', 'hall', 'gym', 'library', 'other'] as const
